import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import ActionNotification from "../../components/ActionNotification";
import { validateEmail } from "../../helpers/Validators";
import { sendResetPasswordEmail } from "../../services/accountService";
import { LOGIN, SIGNUP_MENU } from "../../navigation/Constants";
import NiceModal from "@ebay/nice-modal-react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

const FindYourAccount = () => {
  const history = useHistory();
  const [email, setEmail] = useState<string>("");
  const [errors, setErrors] = useState<any>({});
  const [isSend, setIsSend] = useState<boolean>(false);

  const member = useSelector((state: RootState) => state?.member);

  useEffect(() => {
    if (member?.email) {
      setEmail(member?.email);
    }
  }, []);

  const validateForm = () => {
    let errors: any = {};
    if (email === "") errors["email"] = "חובה להזין דואר אלקטרוני";
    if (!validateEmail(email)) errors["email"] = "כתובת דואר אלקטרוני לא תקינה";
    if (Object.keys(errors).length !== 0) {
      console.log(errors);
      setErrors(errors);
      return false;
    }
    return true;
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (validateForm()) {
      try {
        const { data } = await sendResetPasswordEmail(email);
        setIsSend(data);
      } catch (error: any) {
        setIsSend(true);
        // if (error.response.status === 404) {
        //     NiceModal.show("action_modal", {
        //         onNext: () => history.push(SIGNUP_MENU),
        //         headerTitle: "לא מצאנו את כתובת המייל שהקלדת",
        //         contentTitle: `כדאי לנסות שוב ולוודא שאין טעות בהקלדה. אם עדיין לא נרשמת אלינו - אפשר להצטרף בקלות כאן:`,
        //         seconderyButtonText: "לכניסה מחדש",
        //         primaryButtonText: "להצטרפות",
        //         showCloseButton: true,
        //         showSeconderyButton: true,
        //         isWelcomeModal: false
        //     });
        // }
      }
    }
  };

  const enabled = email.length > 0;

  return isSend ? (
    <ActionNotification
      title={"מעולה,המייל ליצירת סיסמה בדרך אליך"}
      description={
        "אם תוך כמה דקות המייל לא מגיע, כדאי לבדוק אם הוא בתיקיית הספאם"
      }
      showButton={true}
      buttonText={"לכניסה למערכת"}
      isError={false}
      onNext={() => history.goBack()}
    />
  ) : (
    <>
      <div className="top_sec signup wf-section">
        <div className="signup_status_group">
          <a
            href="#"
            onClick={() => history.goBack()}
            className="top_back signup w-inline-block"
          >
            <img src="/assets/images/ic_back_white.svg" loading="lazy" alt="" />
          </a>
        </div>
      </div>
      <div className="content_sec wf-section">
        <div className="signup_top_info">
          <div className="icon_info">
            <img
              src="~/assets/images/ic_info_smoke.svg"
              loading="lazy"
              alt=""
            />
          </div>
          <h2 className="signup_title">שכחת את הסיסמה שלך?</h2>
          <div>כאן אפשר להגדיר אחת חדשה</div>
        </div>
        <div className="login_sec w-form">
          <form onSubmit={handleSubmit}>
            <div className="form_field_content login">
              <div style={{ paddingBottom: 5 }} className="field_block">
                <div className="field_block">
                  <label htmlFor="email">מה כתובת המייל שאיתה נרשמת?</label>
                  <input
                    autoComplete="off"
                    dir="ltr"
                    value={email}
                    name="email"
                    type="email"
                    placeholder="מייל"
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setErrors({});
                    }}
                    maxLength={256}
                    className="txt_field password w-input"
                  />
                  <div
                    className="form_allert"
                    style={{
                      display:
                        errors && errors["newPassword"] ? "contents" : "block",
                    }}
                  >
                    {errors["newPassword"]}
                  </div>
                </div>
              </div>
              <div style={{ margin: "auto", width: "65%" }}>
                <p style={{ padding: "10px" }}>
                  אנחנו נשלח למייל שלך הודעה עם קישור להחלפת הסיסמה
                </p>
              </div>
              <div className="form_buttons_group">
                <input
                  autoComplete="off"
                  disabled={!enabled}
                  type="submit"
                  value={"שליחה"}
                  data-wait=""
                  className={
                    enabled
                      ? "button_full w-button"
                      : "button_full send w-button"
                  }
                ></input>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default FindYourAccount;
